<template>
<div>
    <div v-if="isMobile()">       
        <img class="mobileImg" src="./assets/babyClaimMobile.png" alt="" usemap="#image-map2">
        <div class="mutantCheckMobile">
            <input type="number" id="idCheck" placeholder="Enter Baby #">
            <h2 class="mutantCheckLabel">Check If Baby Claimed</h2>
            <h2 class="mutantCheckLabel2" id="mutantCheckLabel2">{{babyClaimed}}</h2>
        </div>
        <map name="image-map2">
            <area target="" alt="" title="" @click="openModal()" coords="254,392,834,557" shape="rect">
        </map>
    </div>


    <div v-if="!isMobile()" class="desktopBG">
        <img class="desktopImg" src="./assets/babyClaim.png" alt="" usemap="#image-map">
        <map name="image-map">
            <area target="" alt="mutantClaim" title="mutantClaim" @click="openModal()" coords="1465,334,1865,460" shape="rect">
        </map>
        

        <div class="mutantCheck">
            <input type="number" id="idCheck" placeholder="Enter Baby #">
            <h2 class="mutantCheckLabel">Check If Baby Claimed</h2>
            <h2 class="mutantCheckLabel2" id="mutantCheckLabel2">{{babyClaimed}}</h2>
        </div>

    </div>

    <b-modal size="xl" ref="modal-1" hide-footer title="Baby Claim" v-if="babyNftById.length > 0">
            <b-container>
                <b-row>
                    <b-col cols="12">
                        <br><br>
                        <h4 class="centerTxt"  v-if="babyNftById.length > 0">SELECT BABIES FOR VX CLAIM</h4>
                        <br><br>
                        <div v-for="(id) in babyNftById" :key="id">
                            <a @click="addNft(id)" class="cardClick"><b-card
                                :title="'Baby #' + id"
                                tag="duck"
                                class="col-sm-12 col-md-6 col-lg-4 d-flex align-self-stretch clabs"
                                :id="'mutant' + id"
                            >
                            <img  class="imageOfDuck" :src="fusionIPFS + id + '.png'" alt="">
                            </b-card></a>
                        </div>
                        <br><br><br><br>
                        <br><br><br><br>
                        <br><br>
                        <b-icon v-if="loadingTransaction" class="marginButton" icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
                        <button @click="SelectAllBabys()" v-if="!loadingTransaction" class="button-35 marginButton">SELECT ALL</button>
                        <br><br>
                        <button @click="UnselectAllBabys()" v-if="!loadingTransaction" class="button-35">UNSELECT ALL</button>   
                        <br><br>
                        <button v-if="babySelectedNftById.length > 0 && !loadingTransaction" class="button-35" @click="claimVX()">CLAIM VX</button>
                    </b-col>
                </b-row>
            </b-container>
    </b-modal>
</div>
</template>

<script>
import Web3 from 'web3';
import oldBaby from './assets/oldBaby.json'
import newBaby from './assets/newBaby.json'
export default {
    data: function () {
        return {
            web3: '',
            walletAddress: '',
            walletBalance: '',
            babyClaimed: '',

            oldBabyContract: '',
            contractAddress: oldBaby.contractAddress,
            contractABI: oldBaby.abi,

            newBabyContract: '',
            newContractAddress: newBaby.contractAddress,
            newContractABI: newBaby.abi,

            babyNftById: [],
            babySelectedNftById: [],
            fusionIPFS: 'https://cosmiclabs.mypinata.cloud/ipfs/QmaCCkRcv8JqwbqYx1Q7yetWoMc9oC7v3A1JP7LvMmzyGt/',
            loadingTransaction: false
        }
    },
    mounted()
    {
        this.LoadEthWallet()
        $(document).ready(function(e) {
            $('img[usemap]').rwdImageMaps();
        });
        
        var vue = this;
        $('#idCheck').on('input', function() {
            vue.checkID($('#idCheck').val())
        });
    },
    methods: {
        openModal()
        {
            if(this.babyNftById.length > 0)
            {
                this.babySelectedNftById = [];
                this.$refs['modal-1'].show();
            }
            else
            {
                alert("You don't have any Baby VX to claim!");
            }
        },
        checkID(id)
        {
            
            this.newBabyContract.methods.babyClaimed(id).call({from: this.walletAddress})
            .then(res=>{
                if(res)
                {
                    this.babyClaimed = `Baby #${id} has been claimed`
                    document.getElementById("mutantCheckLabel2").style.color = "red"
                }
                else
                {
                    this.babyClaimed = `Baby #${id} has not been claimed`
                    document.getElementById("mutantCheckLabel2").style.color = "green"
                }

            })

            
        },
        SelectAllBabys()
        {   
            this.babySelectedNftById = [];
            for(var i=0;i<this.babyNftById.length;i++)
            {
                this.babySelectedNftById.push(this.babyNftById[i]);
                document.getElementById('mutant' + this.babyNftById[i]).style.background = "#bc33ed";
            }
        },
        UnselectAllBabys()
        {   
            this.babySelectedNftById = [];
            for(var i=0;i<this.babyNftById.length;i++)
            {
                document.getElementById('mutant' + this.babyNftById[i]).style.background = "none";
            }           
        },
        claimVX()
        {
            this.loadingTransaction = true;
            this.newBabyContract.methods.claimVX(this.babySelectedNftById).send({from: this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.loadingTransaction = false;
                this.LoadContract();
                
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        addNft(id)
        {
            var exists = false;
            var existingId;
            for(var i=0; i<this.babySelectedNftById.length;i++)
            {
                if(this.babySelectedNftById[i] == id)
                {
                    exists = true;
                    existingId = i;
                }
            }
            if(!exists)
            {
                this.babySelectedNftById.push(id);
                document.getElementById('mutant' + id).style.background = "#bc33ed";
            }
            else
            {
                this.babySelectedNftById.splice(existingId,1);
                document.getElementById('mutant' + id).style.background = "none";
            }

        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        async chainChange()
        {
            await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                });
            this.LoadEthWallet();
        },
        LoadEthWallet: function(){
            if (typeof window.ethereum !== 'undefined') 
            {
                this.web3 = new Web3(window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/5953fa0192404ecca6c68f5c0ca2dd70") || Web3.givenProvider);
                this.web3.eth.net.getNetworkType()
                .then(network=>{
                    console.log(network)
                    if(network == "main")
                    {
                    
                    this.web3.eth.requestAccounts()
                        .then(acc=>{
                        this.walletAddress = acc[0];
                        this.web3.eth.getBalance(this.walletAddress)
                            .then(balance=>{
                                this.walletBalance = this.web3.utils.fromWei(balance, "ether");
                                this.LoadContract();     
                            });
                        })
                        .catch(err=>{
                            console.log(err);
                        })            
                    }
                    else{
                        this.chainChange();
                    }          
                })
            }
            else
            {
                alert("Please install metamask or use the metamask app if you are on mobile!")
            }
        },
        async LoadContract()
        {
            this.oldBabyContract = new this.web3.eth.Contract(this.contractABI, this.contractAddress);
            this.newBabyContract = new this.web3.eth.Contract(this.newContractABI, this.newContractAddress);

            await this.oldBabyContract.methods.walletOfOwner(this.walletAddress).call({from: this.walletAddress})
            .then(res=>{
                this.babyNftById = res
            })

            var tempArray = [];
            for(var i=0;i<this.babyNftById.length;)
            {
                var currentToken = this.babyNftById[i];
                await this.newBabyContract.methods.babyClaimed(currentToken).call({from: this.walletAddress})
                .then(res2=>{
                    if(!res2)
                    {
                        tempArray.push(currentToken)
                    }
                    else
                    {

                    }
                    i++
                })
            }

            this.babyNftById = tempArray;
        }
    }
}
</script>

<style scoped>
.desktopImg
{
    width: 100%;
    height: 100%;
}

#mutantViewer
{
    position: absolute;
    transform: translate(-50%, -50%);
    top: 25%;
    left: 5%;
    width: 80vh;
    height: 70vh;
    border: 4px solid greenyellow;
}
#idCheck
{
    text-align: center;
}
.mutantCheck
{
    position: absolute;
    transform: translate(-50%, -50%);
    top: 26%;
    left: 20%;
    text-align: center;
    width: 29vh;
}
.mutantCheckLabel
{
    font-size: 3vh;
    color: white;
    text-align: center;    
}
.mutantCheckLabel2
{
    font-size: 3vh;
    color: white;
    text-align: center;     
}


.imageOfDuck
{
    width: 100%;
    margin-top:auto
}
.card-title {
    margin-bottom: 0.5rem;
    font-size: 2vh;
}
.button-34 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  margin: 0;
  position: absolute;
  top: 25%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.marginButton
{
    margin-top: 30vh;
}
.button-35 {
  background: #5E5DF0;
  
  display: block;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
}

.button-36 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.button-37 {
  background: #5E5DF0;
  border-radius: 999px;
  box-shadow: #5E5DF0 0 10px 20px -10px;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  opacity: 1;
  outline: 0 solid transparent;
  padding: 8px 18px;
  width: fit-content;
  word-break: break-word;
  border: 0;
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.clabs
{
    width: 20vh;
    float: left;
    margin-left: 2vh;
    display: flex !important;
    margin-bottom: 2vh;
}
.cardClick
{
    text-decoration: none;
    color: black;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/babyVX/Baby.vue